export default __webpack_public_path__ + "static/media/Logo.1f56eb49.png";